import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'convert-to-html',
  name: 'Convert to HTML',
  category: 'utilities',
  description: 'Convert markdown text to formatted HTML for emails and display',
  icon: 'FileCode',
  color: 'orange',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
